const TabNavigationTypes = {
  Home: 'Home',
  End: 'End',
  ArrowRight: 'ArrowRight',
  ArrowLeft: 'ArrowLeft',
};
const TabNavigationTypesArray = Object.keys(TabNavigationTypes);

export { TabNavigationTypes as T, TabNavigationTypesArray as a };
